<template>
	<div class="public-doctor">
		<navbar></navbar>
		<div v-if="status == 0">
			<md-progress class="md-accent" md-indeterminate></md-progress>
		</div>
		<div v-if="status == 404">
			Az oldal nem található
		</div>
		<div v-if="status == 200">
			<div class="hero">
				<div class="row col-md-offset-3  col-md-6 between-md">
					<div class="avatar" :style="{'background-image': 'url(' + profile.avatar + ')'}"></div>
				</div>
			</div>
			<section class="content">
				<div class="row col-md-offset-3  col-md-6 between-md profile">
					<md-card>
						<md-card-header>
							<div class="md-title">{{profile.name}}</div>
						</md-card-header>
						<md-card-content class="column">
							<div class="row">
								<h3 class="col-xs-12">Adatok</h3>
								<!-- TODO: Rendelőket összesíteni a consultingból -->
								<p class="row">
									<div class="col-md-6"><b>Szakterület:</b> {{profile.doctorData.speciality}}</div>
									<div class="col-md-6"><b>Jellemzők:</b> {{profile.doctorData.specification}}</div>
									<div class="col-md-6"><b>Weboldal:</b> {{profile.doctorData.website}}</div>
									<div class="col-md-6"><b>Facebook oldal:</b> {{profile.doctorData.facebookPageUrl}}</div>
								</p>
							</div>

							<div class="row">
								<h3 class="col-xs-12">Bemutatkozás</h3>
								<p>
									{{profile.doctorData.introduction}}
								</p>
							</div>

							<div class="row" v-if="profile.doctorData.consultingConfig">
								<h3 class="col-xs-12">Rendelési időpontok</h3>
								<p>
									{{profile.doctorData.consultingConfig}}
								</p>
							</div>

							<div class="column">
								<h3 class="col-xs-12">Kapcsolati adatok</h3>
								<div v-if="profile.doctorData.contact.length > 0">
									<p v-for="contact in profile.doctorData.contact">{{contact.name}}: {{contact.value}}</p>
								</div>
								<div v-else>
									Nincs megadva
								</div>
							</div>
						</md-card-content>
					</md-card>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import Navbar from './Navbar'
	import Api from '../../generated'

	let images = require.context('../assets/', false, /\.png$/);
	let placeholder = images('./placeholder.png');

	function fillPlaceholder(profile){
		if(!profile.avatar){
			profile.avatar = placeholder;
		}
		if(!profile.doctorData.speciality){
			profile.doctorData.speciality = "Nincs megadva";
		}
		if(!profile.doctorData.specification){
			profile.doctorData.specification = "Nincs megadva";
		}
		if(!profile.doctorData.website){
			profile.doctorData.website = "Nincs megadva";
		}
		if(!profile.doctorData.facebookPageUrl){
			profile.doctorData.facebookPageUrl = "Nincs megadva";
		}
		if(!profile.doctorData.introduction){
			profile.doctorData.introduction = "Nincs megadva";
		}
		return profile;
	}

	export default {
		components: {
			Navbar
		},
		data(){
			return{
				status: 0,
				profile: {
					doctorData:{}
				}
			}
		},
		mounted(){
			this.status = 0
			Api.ApiClient.instance.findDoctorByName(this.$route.params.name, (error, data, response) => {
				if (error) {
					console.error(error);
					this.status = 404
				} else {
					this.profile = fillPlaceholder(data);
					console.log(this.profile);
					this.status = 200
				}
			});
		}
	}
</script>

<style scoped>
	.content{
		margin-top: -16px;
		margin-bottom: 16px;
	}
	.hero{
		background-image: url('~../assets/pattern.png');
		background-color: #367FFA;
		min-height: 200px;
		text-align: center;
		color: #fff;
		padding-bottom: 24px
	}
	.avatar{
		border: 3px solid #fff;
		border-radius: 8px;
		width: 150px;
		height: 150px;
		margin-top: 20px;
		background-color: #eee;
		background-size: cover
	}
	.md-card{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// PublicDoctorView.vue?ecb9dd5c